
export default {
  methods: {
    $_getHeadersWidthByCoef(headers) {
      let width = 0
      headers.forEach(el => {
        if ( !(+el?.coef_width) ) {
          return
        }
        if ( el.text ) {
          width += +el.coef_width
        }
      })

      headers.forEach(el => {
        if ( !(+el?.coef_width) ) {
          return
        }
        if ( el.text ) {
          el.width = ( el.coef_width * (100 / width)).toFixed(2) + '%'
        }
      })
    },
    $_createResizeColumn(table) {
      if (!table) { return }

      const deleteDiv = (element) => {
        if (!(element instanceof HTMLElement)) {
          return
        }

        const resizeColumnElement = element.querySelector('#resizeColumn')

        if (resizeColumnElement) {
          resizeColumnElement.remove()
        }
      }
      const recreateHeight = () => {
        if (!table.$el || !(table.$el instanceof HTMLElement)) {
          return
        }

        var tableHeight = table.$el.offsetHeight
        const resizeColumnsElement = table.$el.querySelectorAll('#resizeColumn')
        Array.from(resizeColumnsElement)?.forEach((resizeColumnElement) => {
          resizeColumnElement.style.height = tableHeight + 'px'
        })
      }

      const createDiv = (height) => {
        var div = document.createElement('div')
        div.id = 'resizeColumn'
        div.style.top = 0
        div.style.right = 0
        div.style.width = '5px'
        div.style.position = 'absolute'
        div.style.cursor = 'col-resize'
        div.style.userSelect = 'none'
        div.style.height = height + 'px'
        return div
      }
      const getStyleVal = (elm,css) => {
        return (window.getComputedStyle(elm, null).getPropertyValue(css))
      }
      const paddingDiff = (col) => {
        if (getStyleVal(col,'box-sizing') == 'border-box') {
          return 0
        }

        var padLeft = getStyleVal(col,'padding-left')
        var padRight = getStyleVal(col,'padding-right')
        return (parseInt(padLeft) + parseInt(padRight))
      }
      const setListeners = (div) => {
        var pageX,curCol,nxtCol,curColWidth,nxtColWidth

        div.addEventListener('mousedown', function (e) {
          curCol = e.target.parentElement
          nxtCol = curCol.nextElementSibling
          pageX = e.pageX

          var padding = paddingDiff(curCol)

          curColWidth = curCol.offsetWidth - padding
          if (nxtCol) { nxtColWidth = nxtCol.offsetWidth - padding }
        })

        div.addEventListener('mouseover', function (e) {
          e.target.style.borderRight = '2px solid rgba(var(--black-color-rgba), 0.12)'
        })

        div.addEventListener('mouseout', function (e) {
          e.target.style.borderRight = ''
        })

        document.addEventListener('mousemove', function (e) {
          if (curCol) {
            var diffX = e.pageX - pageX

            if (nxtCol) { nxtCol.style.width = (nxtColWidth - (diffX)) + 'px' }

            curCol.style.width = (curColWidth + diffX) + 'px'
          }
        })

        document.addEventListener('mouseup', function () {
          curCol = undefined
          nxtCol = undefined
          pageX = undefined
          nxtColWidth = undefined
          curColWidth = undefined
          recreateHeight()
        })
      }
      const resizableGrid = (table) => {
        var row = table.getElementsByTagName('tr')[0],
          cols = row ? row.children : undefined
        if (!cols) { return }

        table.style.overflow = 'hidden'

        var tableHeight = table.offsetHeight

        for (var i = 0;i < cols.length;i++) {
          deleteDiv(cols[i])
          var div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'
          setListeners(div)
        }
      }
      resizableGrid(table.$el)
      /*var tables = document.getElementsByTagName('table')
      for (var i = 0; i < tables.length;i++) {
        resizableGrid(tables[i])
      }*/

    }
  }
}
